const ID_TOKEN = "";

export default ID_TOKEN;
